<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-27 10:38:50
-->
<template>
	<div>
		<el-drawer
			:title="`橱窗${showcaseType}配置`"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="size"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<!-- 弹窗内容部分 -->
				<el-form :model="formData" :rules="rules" ref="form" :label-width="labelWidth">
					<el-form-item :label="`橱窗样式${showcaseType}`">
						<div class="showcase-style1 flex">
							<img style="width: 100px" :src="require(`@/assets/public/showcase-style${showcaseType}.png`)" alt="" />
							<el-popover placement="bottom" :width="413" trigger="hover">
								<div class="align-center pl-20 pr-20 pt-20 pb-20">
									<p class="yx-color-pure-1 font-h4-regular">橱窗样式{{ showcaseType }}</p>
									<p class="font-h4-regular yx-color-blue-6">可自定义橱窗背景图；点击整体可跳转到指定的集合页；</p>
									<p class="font-h4-regular yx-color-blue-6">可向右滑动查看10个商品</p>
									<img :src="require(`@/assets/public/showcase-img${showcaseType}.png`)" style="width: 349px" alt="" />
								</div>
								<p class="yx-color-primary ml-12 font-h4-regular cursor-pointer" slot="reference">示例</p>
							</el-popover>
						</div>
					</el-form-item>
					<el-form-item label="橱窗标题" prop="title">
						<el-input v-model="formData.title" placeholder="请输入最多30字" maxlength="30" show-word-limit />
					</el-form-item>

					<div v-for="(item, index) in configList" :key="index">
						<p class="yx-color-pure-1 font-h4-medium mb-20">区域 {{ index + 1 }} 配置：</p>
						<div style="padding-left: 30px">
							<el-form-item prop="imageUrl">
								<div slot="label" class="flex-row flex-align-center">
									<p class="yx-color-danger mr-2">*</p>
									<p>上传图片</p>
								</div>
								<div class="flex flex-align-end">
									<uploadImg
										:key="visible"
										@saveCardLink="saveCardLink($event, item)"
										:limitSize="item.limitSize"
										:widthAndHeight="item.widthAndHeight"
										:accept="item.accept"
										:default_img="item.imageUrl"
										ref="uploadImg"
										class="upload-img"
									></uploadImg>
									<p class="yx-color-blue-6 ml-10 font-h6-regular">{{ item.uploadDesc }}</p>
								</div>
							</el-form-item>
							<el-form-item label="" prop="linkType" v-if="item.isShowskipType">
								<div slot="label" class="flex-row flex-align-center">
									<p class="yx-color-danger mr-2">*</p>
									<p>跳转类型</p>
								</div>
								<div class="flex flex-align-center mb-24" v-if="item.isShowSelectGoods">
									<p style="width: 130px; flex-shrink: 0" class="yx-color-text-p-4">
										<el-radio v-model="item.linkType" class="yx-color-text-p-4" label="1">商品详情</el-radio>
									</p>
									<el-button type="primary" @click="addGoods(item.product_id, index)" :disabled="item.linkType !== '1'" plain>选择商品</el-button>
									<p class="flex flex-align-center ml-24" v-if="item.product_id">
										<el-tooltip placement="top" :content="item.product_name" v-ak-tooltip-auto-show>
											<span :class="['line-ellipsis-1 mr-18', item.linkType !== '1' ? 'disable-style' : 'yx-color-pure-1']" style="max-width: 360px">
												已选：{{ item.product_name }}
											</span>
										</el-tooltip>
										<el-button type="text" :disabled="item.linkType !== '1'" @click="openPreview(item, 'productId')">预览</el-button>
									</p>
								</div>
								<div class="flex">
									<p style="width: 130px; flex-shrink: 0" class="yx-color-text-p-4">
										<el-radio v-model="item.linkType" label="2">活动集合页</el-radio>
									</p>
									<div>
										<div class="flex">
											<el-button type="primary" @click="addCollection(item.gatherId, index)" :disabled="item.linkType !== '2'" plain>
												选择集合页
											</el-button>
											<p class="flex flex-align-center ml-24" v-if="item.gatherId">
												<el-tooltip placement="top" :content="item.bannerTitle" v-ak-tooltip-auto-show>
													<span
														:class="['line-ellipsis-1 mr-18', item.linkType !== '2' ? 'disable-style' : 'yx-color-pure-1']"
														style="max-width: 330px"
													>
														已选：{{ item.bannerTitle }}
													</span>
												</el-tooltip>
												<el-button type="text" :disabled="item.linkType !== '2'" @click="openPreview(item, 'gatherId')">预览</el-button>
											</p>
										</div>

										<p class="font-h6-regular yx-color-blue-6 mt-12" v-if="item.linkType === '2'">
											<i class="el-icon-info"></i>
											<span class="ml-4">若未找到您可</span>
											<span class="ml-4 yx-color-primary cursor-pointer" @click="createCollection">新建集合页</span>
										</p>
									</div>
								</div>
								<div class="mt-24" v-if="item.isShowSelectGoods">
									<p style="width: 130px" class="yx-color-text-p-4">
										<el-radio v-model="item.linkType" label="3">小程序</el-radio>
									</p>
									<div class="mt-12 ml-24" v-if="item.linkType === '3'">
										<p><el-input v-model="item.linkUrlAppid" style="width: 240px" placeholder="请输入小程序appid"></el-input></p>
										<p class="mt-8"><el-input v-model="item.linkUrl" style="width: 240px" placeholder="请输入跳转页面"></el-input></p>
									</div>
								</div>
							</el-form-item>
						</div>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading" :disabled="!isDisabled">确认</el-button>
			</div>
		</el-drawer>

		<!-- 添加集合页 -->
		<addCollectionDrawer ref="addCollectionDrawer" :size="640" :platformId="platformId" />

		<!-- 选择集合页 -->
		<selectCollectionDrawer ref="selectCollectionDrawer" @confirmAddCollection="confirmAddCollection" :platformId="platformId" />

		<!-- 添加商品 -->
		<addGoodsDrawer ref="addGoodsDrawer" @confirmAddGoods="confirmAddGoods" :platformId="platformId" />

		<!-- 预览 -->
		<previewDialog ref="previewDialog" />
	</div>
</template>
<script>
import uploadImg from '@/components/common/uploadImg';
import selectCollectionDrawer from '../selectCollectionDrawer';
import addGoodsDrawer from '@/components/business/addGoodsDrawer';
import addCollectionDrawer from '../addCollectionDrawer';
import { updateShowCase, updateShowCaseTow } from '@/api/selectionDecoration';
import previewDialog from '../previewDialog';
export default {
	components: {
		uploadImg,
		selectCollectionDrawer,
		addGoodsDrawer,
		addCollectionDrawer,
		previewDialog,
	},
	props: {
		size: {
			type: Number,
			default: 800,
		},
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	computed: {
		// 添加商品组抽屉宽度自适应
		groupSize({ size }) {
			const obj = {
				800: 700,
				640: 520,
			};
			return obj[size];
		},
		isDisabled({ showcaseType, formData, configList }) {
			const check = this.checkFun(0);
			if (showcaseType === 1) {
				return formData.title && check;
			} else {
				const check1 = this.checkFun(1);
				const check2 = this.checkFun(2);
				const check3 = this.checkFun(3);
				return formData.title && configList[0].imageUrl && check1 && check2 && check3;
			}
		},
	},
	data() {
		return {
			visible: false, // 弹窗显隐
			formData: {
				title: '',
			}, // 表单数据
			rules: {
				title: [{ required: true, message: '请输入橱窗标题', trigger: 'blur' }],
			},
			loading: false, // 按钮loading状态
			showcaseType: 1, //1样式1, 2样式2
			configList: [],
			locationList: [],
		};
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(type = 1, { title, locationList }) {
			this.formData.title = title || '';
			this.locationList = locationList || [];
			this.showcaseType = type;
			this.visible = true;
			this.getConfig();
		},
		addGoods(product_id, index) {
			this.$refs.addGoodsDrawer.show(product_id, index);
		},
		addCollection(gatherId, index) {
			this.$refs.selectCollectionDrawer.show(gatherId, index);
		},
		confirmAddGoods(val, index) {
			Object.keys(val).forEach(key => (this.configList[index][key] = val[key]));
		},
		confirmAddCollection(val, index) {
			Object.keys(val).forEach(key => (this.configList[index][key] = val[key]));
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.formData = {
				title: '',
			};
			this.getConfig();
			this.showcaseType = 1;
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		async confirm() {
			// 按钮loading开启
			this.loading = true;
			try {
				const { showcaseType, platformId, formData } = this;
				const { title } = formData;
				const api = {
					1: updateShowCase,
					2: updateShowCaseTow,
				};
				const params = this.getParams();
				await api[showcaseType]({ ...params, platformId, title });
				this.$message.success('修改成功');
				this.loading = false;
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
		getParams() {
			const { showcaseType } = this;
			const link = {
				1: 'product_id',
				2: 'gatherId',
			};
			let data = [];
			data = this.configList.map(item => ({
				imageUrl: item.imageUrl,
				linkType: item.linkType,
				link: item.linkType !== '3' ? item[link[item.linkType]] : '',
				linkUrlAppid: item.linkType === '3' ? item.linkUrlAppid : '',
				linkUrl: item.linkType === '3' ? item.linkUrl : '',
			}));
			let params = {
				1: data[0],
				2: {
					data,
				},
			};
			return params[showcaseType];
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 表单项标签宽度
			this.labelWidth = '100px';
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		createCollection() {
			this.$refs.addCollectionDrawer.show();
		},
		saveCardLink(val, item) {
			item.imageUrl = val;
		},
		checkFun(index) {
			return (
				this.configList[index]?.imageUrl &&
				((this.configList[index]?.linkType === '2' && this.configList[index]?.gatherId) ||
					(this.configList[index]?.linkType === '1' && this.configList[index]?.product_id) ||
					(this.configList[index]?.linkType === '3' && this.configList[index]?.linkUrlAppid))
			);
		},
		getConfig() {
			const { showcaseType } = this;
			const obj = {
				2: [
					{
						uploadDesc: '请上传JPG/PNG/GIF 格式的图片，尺寸 1053 * 732，大小不超过2M',
						limitSize: 2,
						widthAndHeight: [1053, 732],
						accept: ['png', 'jpg', 'gif'],
						isShowskipType: false,
						isShowSelectGoods: true,
						imageUrl: '',
						product_id: '',
						product_name: '',
						gatherId: '',
						bannerTitle: '',
						linkType: '1',
					},
					{
						uploadDesc: '请上传JPG/PNG/GIF 格式的图片，尺寸 480 * 549 ，大小不超过1M',
						widthAndHeight: [480, 549],
						limitSize: 1,
						accept: ['png', 'jpg', 'gif'],
						isShowskipType: true,
						isShowSelectGoods: true,
						imageUrl: '',
						product_id: '',
						product_name: '',
						gatherId: '',
						bannerTitle: '',
						linkType: '1',
						linkUrlAppid: '',
						linkUrl: '',
					},
					{
						uploadDesc: '请上传JPG/PNG/GIF 格式的图片，尺寸 480 * 264，大小不超过1M',
						limitSize: 1,
						widthAndHeight: [480, 264],
						accept: ['png', 'jpg', 'gif'],
						isShowskipType: true,
						isShowSelectGoods: true,
						imageUrl: '',
						product_id: '',
						product_name: '',
						gatherId: '',
						bannerTitle: '',
						linkType: '1',
						linkUrlAppid: '',
						linkUrl: '',
					},
					{
						uploadDesc: '请上传JPG/PNG/GIF 格式的图片，尺寸 480 * 264，大小不超过1M',
						limitSize: 1,
						widthAndHeight: [480, 264],
						accept: ['png', 'jpg', 'gif'],
						isShowskipType: true,
						isShowSelectGoods: true,
						imageUrl: '',
						product_id: '',
						product_name: '',
						gatherId: '',
						bannerTitle: '',
						linkType: '1',
						linkUrlAppid: '',
						linkUrl: '',
					},
				],
				1: [
					{
						uploadDesc: '请上传JPG/PNG/GIF 格式的图片，尺寸 1053 * 549 ，大小不超过1M',
						limitSize: 1,
						widthAndHeight: [1053, 549],
						accept: ['png', 'jpg', 'gif'],
						isShowskipType: true,
						isShowSelectGoods: false,
						imageUrl: '',
						product_id: '',
						product_name: '',
						gatherId: '',
						bannerTitle: '',
						linkType: '2',
						linkUrlAppid: '',
						linkUrl: '',
					},
				],
			};
			this.configList = obj[showcaseType].map((item, index) => ({
				...item,
				gatherId: this.locationList[index]?.linkType === '2' ? this.locationList[index].link : '',
				bannerTitle: this.locationList[index]?.linkType === '2' ? this.locationList[index].linkName : '',
				product_id: this.locationList[index]?.linkType === '1' ? this.locationList[index].link : '',
				product_name: this.locationList[index]?.linkType === '1' ? this.locationList[index].linkName : '',
				linkType: this.locationList[index]?.linkType || item.linkType,
				imageUrl: this.locationList[index]?.imageUrl || item.imageUrl,
				linkUrlAppid: this.locationList[index]?.linkType === '3' ? this.locationList[index].linkUrlAppid : '',
				linkUrl: this.locationList[index]?.linkType === '3' ? this.locationList[index].linkUrl : '',
			}));
		},
		openPreview({ product_id, gatherId, linkType }, key) {
			const { platformId } = this;
			const obj = {
				productId: product_id,
				gatherId: gatherId,
			};
			this.$refs.previewDialog.show({ preview: 'preview_goods', platformId, link: obj[key], linkType });
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.disable-style {
		color: #c9cdd4;
	}
	::v-deep .el-form-item {
		margin-bottom: 24px;
	}
	::v-deep .el-radio__label {
		color: #4e596a;
	}
	.upload-img {
		/deep/ .el-upload--picture-card {
			background-color: #fff;
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload--picture-card {
			background-color: #fff;
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload--picture-card i {
			font-size: 16px;
			color: #86909d;
		}
		/deep/ .el-upload-list--picture-card .el-upload-list__item {
			width: 60px;
			height: 60px;
		}
	}
}
.drawer-footer {
	background-color: #fff;
	z-index: 999;
}
</style>
